import SectionShell from "./SectionShell";
import ToggleSwitch from "../../Setting/components/printers/ToggleSwitch";

const FeaturesSection = ({ features, isLoading, isSavingKey, onToggle }) => {
  const rows = [
    { key: "clientLogin", label: "Client Login" },
    { key: "takeaway", label: "Takeaway" },
    { key: "onlineOrders", label: "Online Orders" },
    { key: "tableBooking", label: "Table Booking" },
    { key: "feedback", label: "Feedbacks" },
    { key: "qrFeature", label: "QR Feature" },
    { key: "availableTimeManage", label: "Menu Availability Scheduler" },
  ];

  const midPoint = Math.ceil(rows.length / 2);
  const columnRows = [rows.slice(0, midPoint), rows.slice(midPoint)];

  const renderTable = (tableRows) => (
    <div className="border border-gray-100 rounded-xl overflow-hidden self-start">
      <table className="w-full text-sm">
        <thead className="bg-gray-50">
          <tr className="text-left text-xs text-gray-500 uppercase tracking-widest">
            <th className="px-4 py-3">Feature</th>
            <th className="px-4 py-3">Status</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {tableRows.map((r) => {
            const checked = !!features?.[r.key];
            const isSaving = isSavingKey === r.key;

            return (
              <tr key={r.key} className="bg-white">
                <td className="px-4 py-3 font-semibold text-gray-900">{r.label}</td>
                <td className="px-4 py-3">
                  <div className={isSaving ? "opacity-60 pointer-events-none" : ""}>
                    <ToggleSwitch
                      checked={checked}
                      onChange={(next) => onToggle(r.key, next)}
                      labelOn="Enabled"
                      labelOff="Disabled"
                    />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

  return (
    <SectionShell
      number="4"
      title="Features"
      subtitle="Enable/disable the following features."
    >
      <div className="flex items-center justify-between mb-3">
        <div className="text-xs font-semibold text-gray-500 uppercase tracking-widest">
          Available Features
        </div>
        {isLoading ? <div className="text-xs text-gray-500">Loading...</div> : null}
      </div>

      <div className="block md:hidden">
        {renderTable(rows)}
      </div>

      <div className="hidden md:grid grid-cols-2 gap-4">
        {columnRows.map((colRows, idx) => {
          if (colRows.length === 0) return null;
          return <div key={idx}>{renderTable(colRows)}</div>;
        })}
      </div>
    </SectionShell>
  );
};

export default FeaturesSection;
